var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.162,
    height: 44.274,
    viewBox: "0 0 97.162 44.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#080808}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-19.838 -67.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_234",
    "data-name": "Group 234",
    transform: "translate(19.838 67.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_194",
    fill: "#3bbacc",
    d: "M144.515 112.1a21.966 21.966 0 0 1-13.075-4.271l2.329-3.178a18.2 18.2 0 1 0-.829-28.732l-2.507-3.038a22.138 22.138 0 1 1 14.082 39.219z",
    "data-name": "Path 194",
    transform: "translate(-69.49 -67.827)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_233",
    "data-name": "Group 233",
    transform: "translate(0 13.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_195",
    d: "M33.634 106.669a6.724 6.724 0 0 1-5.794 3 7.5 7.5 0 0 1-5.691-2.483 8.711 8.711 0 0 1-2.311-6.209 8.81 8.81 0 0 1 2.276-6.177 7.42 7.42 0 0 1 5.726-2.484 6.714 6.714 0 0 1 5.794 2.9v-2.481H36.7v16.521h-3.066zm-1.518-1.552a6.066 6.066 0 0 0 1.518-4.139 5.919 5.919 0 0 0-1.518-4.1 4.937 4.937 0 0 0-3.828-1.655 5.062 5.062 0 0 0-3.863 1.655 5.79 5.79 0 0 0-1.552 4.1 5.932 5.932 0 0 0 1.552 4.139 4.975 4.975 0 0 0 3.863 1.69 4.854 4.854 0 0 0 3.829-1.69z",
    className: "prefix__cls-2",
    "data-name": "Path 195",
    transform: "translate(-19.838 -92.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_196",
    d: "M61.14 109.352h-3.07v-16.52h3.07V94.9a5.3 5.3 0 0 1 4.76-2.482 5.609 5.609 0 0 1 5.519 3.346 6.023 6.023 0 0 1 2.1-2.449 5.829 5.829 0 0 1 3.311-.932 6.078 6.078 0 0 1 4.622 1.828 6.958 6.958 0 0 1 1.724 4.967v10.106h-3.07v-9.623a4.719 4.719 0 0 0-1.035-3.208 3.621 3.621 0 0 0-2.863-1.207 3.768 3.768 0 0 0-2.932 1.207 4.568 4.568 0 0 0-1.069 3.208v9.623h-3.031v-9.623a4.566 4.566 0 0 0-1.07-3.208 3.743 3.743 0 0 0-2.9-1.207 3.623 3.623 0 0 0-2.9 1.173 4.751 4.751 0 0 0-1.035 3.242z",
    className: "prefix__cls-2",
    "data-name": "Path 196",
    transform: "translate(-37.003 -92.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_197",
    d: "M114.3 92.7v2.518a6.643 6.643 0 0 1 5.759-2.932 7.5 7.5 0 0 1 5.691 2.484 9.448 9.448 0 0 1 .069 12.382 7.42 7.42 0 0 1-5.725 2.483 6.638 6.638 0 0 1-5.76-2.828v7.762h-3.069V92.7zm5.449 2.448a4.977 4.977 0 0 0-3.863 1.69 6.3 6.3 0 0 0-.034 8.244 5.253 5.253 0 0 0 7.656 0 5.916 5.916 0 0 0 1.518-4.1 6.065 6.065 0 0 0-1.518-4.139 4.856 4.856 0 0 0-3.828-1.69z",
    className: "prefix__cls-2",
    "data-name": "Path 197",
    transform: "translate(-60.884 -92.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_198",
    d: "M149.317 96.89a1.8 1.8 0 0 0 .966 1.586 8.349 8.349 0 0 0 2.38.965 28.852 28.852 0 0 1 2.794.862 5.909 5.909 0 0 1 2.379 1.586 3.993 3.993 0 0 1 .966 2.794 4.362 4.362 0 0 1-1.69 3.553 7.313 7.313 0 0 1-4.759 1.38q-4.449 0-6.622-2.69l1.794-2a6.136 6.136 0 0 0 5.035 2.207 3.649 3.649 0 0 0 2.345-.655 2.157 2.157 0 0 0 .828-1.759 1.96 1.96 0 0 0-.965-1.69 8.391 8.391 0 0 0-2.311-1.069c-.9-.276-1.794-.586-2.724-.931a5.9 5.9 0 0 1-2.38-1.587 3.846 3.846 0 0 1-.966-2.69 4.1 4.1 0 0 1 1.621-3.242 6.548 6.548 0 0 1 4.346-1.346c2.9 0 4.932.863 6.139 2.552l-1.828 1.828a5.067 5.067 0 0 0-4.242-1.9 3.844 3.844 0 0 0-2.207.587 2.026 2.026 0 0 0-.899 1.659z",
    className: "prefix__cls-2",
    "data-name": "Path 198",
    transform: "translate(-76.358 -92.164)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo-02.d4abcda9d253302c67adf5a680540aa3.svg";
export { ForwardRef as ReactComponent };